export default function EmptyState({ title, subtitle, action, icon, testid }) {
  return (
    <div
      data-testid={testid}
      className="rounded-2xl border p-12 text-center"
      style={{ background: "#FAF6EC", borderColor: "rgba(27,67,50,0.12)" }}
    >
      {icon && (
        <div
          className="mx-auto inline-flex h-14 w-14 items-center justify-center rounded-full"
          style={{ background: "#fff", color: "#1B4332", border: "1px solid rgba(201,168,76,0.5)" }}
        >
          {icon}
        </div>
      )}
      <h3 className="font-serif text-2xl mt-5" style={{ color: "#1B4332" }}>{title}</h3>
      {subtitle && <p className="mt-2 text-sm max-w-md mx-auto" style={{ color: "#6E6759" }}>{subtitle}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
